export const isValidEmail = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
